type FullWidthSectionProps = {
  className?: string
  children: React.ReactNode
}
export const FullWidthSection = ({
  className = '',
  children,
}: FullWidthSectionProps) => {
  return (
    <div
      className={`relative left-1/2 right-1/2 -translate-x-1/2 w-screen ${className}`}
    >
      {children}
    </div>
  )
}
